module.exports = {

}



/** WEBPACK FOOTER **
 ** ./src/lib/conditions.js
 **/